import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useMemo, useState } from 'react';

import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import Table from 'components/table/Table';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { ADVANCE_WMS_MODULE } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const BinItems = NiceModal.create(({ id, binName }) => {
	const axios = useAxiosPrivate();

	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);

	const columns = useMemo(
		() => [
			{ id: 'productName', header: 'productName', size: 150, accessorKey: 'name' },
			{ id: 'sku', header: 'sku', size: 150, accessorKey: 'sku' },
			{ id: 'quantity', header: 'quantity', size: 150, accessorKey: 'quantity' }
		],
		[]
	);

	const fillForm = async () => {
		setLoading(true);
		try {
			const { data } = await axios.post(ADVANCE_WMS_MODULE.GET_BIN_BY_ID, { id });
			const binInventoryItems = data?.binInventoryItems;

			binInventoryItems && setData(binInventoryItems);
		} catch (error) {
			AppLogger.error(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		id && fillForm();
	}, [id]);

	return (
		<Modal>
			<ModalTitle>
				<Typography variant="p1">bins.binsItems</Typography>
				<span className="mx-1" />
				<Typography variant="p1" fontWeight="500">
					({`${binName} (ID: ${id})`})
				</Typography>
			</ModalTitle>
			<ModalContent>
				<Table data={data} loading={loading} columns={columns} />
			</ModalContent>
			<ModalActions></ModalActions>
		</Modal>
	);
});

export default BinItems;
